/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import gameData from '@/store/gameData/';

//------------------------------------------------------------
// STATE
//------------------------------------------------------------

const state = {
	local: gameData.state.fileSystems.FS_PLAYER
}

// console.log(gameData.state.fileSystems.FS_PLAYER);

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
    state,
    getters,
    actions,
    mutations,
}
//===========================================
//
//===========================================